// RedemptionQRModal.js - Modal to display QR code after redemption
import React from 'react';
import ReactDOM from 'react-dom';
import { QRCodeSVG } from 'qrcode.react';
import './RedemptionQRModal.css';

const RedemptionQRModal = ({ isOpen, onClose, redemptionId, reward }) => {
  console.log('RedemptionQRModal render:', { isOpen, redemptionId, reward: reward?.title });
  
  if (!isOpen) return null;

  const verificationUrl = `${window.location.origin}/verify-reward/${redemptionId}`;

  const handleDownload = () => {
    const svg = document.getElementById('redemption-qr-code');
    const svgData = new XMLSerializer().serializeToString(svg);
    const canvas = document.createElement('canvas');
    const ctx = canvas.getContext('2d');
    const img = new Image();
    
    img.onload = () => {
      canvas.width = img.width;
      canvas.height = img.height;
      ctx.drawImage(img, 0, 0);
      const pngFile = canvas.toDataURL('image/png');
      
      const downloadLink = document.createElement('a');
      downloadLink.download = `reward-qr-${redemptionId}.png`;
      downloadLink.href = pngFile;
      downloadLink.click();
    };
    
    img.src = 'data:image/svg+xml;base64,' + btoa(svgData);
  };

  const modalContent = (
    <div className="qr-modal-overlay" onClick={onClose}>
      <div className="qr-modal-content" onClick={(e) => e.stopPropagation()}>
        <button className="qr-modal-close" onClick={onClose}>×</button>
        
        <div className="qr-modal-header">
          <div className="success-icon">✓</div>
          <h2>Reward Redeemed!</h2>
          <p className="qr-subtitle">Show this QR code to the merchant</p>
        </div>

        <div className="qr-code-container">
          <div className="qr-code-wrapper">
            <QRCodeSVG
              id="redemption-qr-code"
              value={verificationUrl}
              size={280}
              level="H"
            />
          </div>
        </div>

        <div className="reward-summary">
          <h3>{reward?.merchantName}</h3>
          <p className="reward-title">{reward?.title}</p>
          <div className="discount-display">
            <span className="discount-value">{reward?.discount}</span>
            <span className="discount-label">OFF</span>
          </div>
        </div>

        <div className="qr-instructions">
          <h4>How to use:</h4>
          <ol>
            <li>Show this QR code to the merchant</li>
            <li>Merchant will scan to verify your redemption</li>
            <li>Valid for <strong>24 hours</strong> from generation</li>
            <li>You can redeem this offer multiple times</li>
          </ol>
        </div>

        <div className="qr-modal-actions">
          <button className="btn-download" onClick={handleDownload}>
            📥 Download QR Code
          </button>
          <button className="btn-close" onClick={onClose}>
            Close
          </button>
        </div>

        <div className="qr-modal-footer">
          <small>Redemption ID: {redemptionId}</small>
        </div>
      </div>
    </div>
  );

  // Render modal in a portal to prevent parent re-renders from unmounting it
  return ReactDOM.createPortal(
    modalContent,
    document.body
  );
};

export default RedemptionQRModal;
